/*
  New Era — redirecciones de búsqueda.

  Si alguien busca un término de campaña, se le lleva a la página de esa
  campaña en vez de a los resultados. Se intercepta el envío del formulario,
  así que el navegador NUNCA llega a cargar /search: va directo al destino.

  Se carga desde layout/theme.liquid, en todas las páginas, y tiene que ser
  así: el buscador vive en el header, o sea que se puede buscar desde
  cualquier página. Si esto se cargara solo en la plantilla de búsqueda, ya
  sería tarde.
*/
(function () {
  const normalize = (s) =>
    s
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  /*
    Las reglas se editan desde el tema, en Ajustes → Redirecciones de búsqueda,
    no aquí. Una por línea:

        hot sale | /pages/hot-sale-new-era
        promociones, descuento, oferta | /collections/descuento-30

    Antes vivían en este archivo, así que montar una campaña obligaba a tocar
    código y desplegar.
  */
  function parseRules(texto) {
    const reglas = [];

    for (const linea of String(texto || '').split('\n')) {
      const l = linea.trim();
      if (!l || l.charAt(0) === '#') continue;

      const corte = l.indexOf('|');
      if (corte === -1) continue;

      const url = l.slice(corte + 1).trim();
      const terms = l
        .slice(0, corte)
        .split(',')
        .map((t) => normalize(t))
        .filter(Boolean);

      /*
        Solo se admiten rutas del propio sitio. Sin esto, cualquiera con
        acceso al editor del tema podría mandar el tráfico de una búsqueda a
        otro dominio. Se descarta también "//otro-sitio.com", que el navegador
        entiende como URL absoluta.
      */
      if (!url || url.charAt(0) !== '/' || url.charAt(1) === '/') continue;
      if (!terms.length) continue;

      reglas.push({ terms: terms, url: url });
    }

    return reglas;
  }

  const redirects = parseRules(window.newEraSearchRedirects);
  if (!redirects.length) return;

  function getRedirectUrl(query) {
    const q = normalize(query || '');
    if (!q) return null;
    for (const rule of redirects) {
      if (rule.terms.indexOf(q) !== -1) return rule.url;
    }
    return null;
  }

  /*
    Solo cuenta como búsqueda un formulario que apunte a /search.

    Hace falta comprobarlo: el formulario de filtros (#CollectionFilterForm de
    snippets/faceted-filters.liquid) también lleva un <input name="q"> oculto,
    para conservar el término al filtrar. Sin esta comprobación, aplicar un
    filtro en la página de búsqueda podía dispararse como si fuera una
    búsqueda nueva y sacar al cliente de sus resultados. Ese formulario no
    tiene action, así que se distingue solo.

    Se compara la ruta ya resuelta por el navegador, no la cadena escrita, para
    que siga valiendo si algún día la tienda usa prefijo de idioma
    (/es-mx/search).
  */
  function esBusqueda(ruta) {
    return ruta === '/search' || ruta.endsWith('/search');
  }

  function formularioDeBusqueda(form) {
    if (!form || !form.getAttribute('action')) return false;
    try {
      return esBusqueda(new URL(form.action, window.location.origin).pathname);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!formularioDeBusqueda(form)) return;
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      const url = getRedirectUrl(input.value);
      if (url) {
        e.preventDefault();
        window.location.href = url;
      }
    },
    true
  );

  // Respaldo: por si alguien llega directo a /search con la URL escrita o guardada.
  if (esBusqueda(window.location.pathname)) {
    const params = new URLSearchParams(window.location.search);
    const url = getRedirectUrl(params.get('q'));
    if (url) window.location.replace(url);
  }
})();
